import axiosInstance from '@/lib/axios';

export interface Proposal {
  id: string;
  _id?: string;
  title: string;
  client: string;
  value: number;
  status: 'Draft' | 'Sent' | 'Accepted' | 'Rejected';
  sentDate: string | null;
  validUntil: string;
  version: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ProposalFormData {
  title: string;
  client: string;
  value: number;
  status: 'Draft' | 'Sent' | 'Accepted' | 'Rejected';
  sentDate: string | null;
  validUntil: string;
  version: string;
}

export interface ProposalListResponse {
  data: Proposal[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

export interface ProposalFilters {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  client?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export async function getProposals(filters: ProposalFilters = {}): Promise<ProposalListResponse> {
  const params = new URLSearchParams();
  
  if (filters.page) params.append('page', filters.page.toString());
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.search) params.append('search', filters.search);
  if (filters.status) params.append('status', filters.status);
  if (filters.client) params.append('client', filters.client);
  if (filters.sort) params.append('sort', filters.sort);
  if (filters.order) params.append('order', filters.order);

  const response = await axiosInstance.get(`/proposals?${params.toString()}`);
  return response.data;
}

export async function getProposalById(id: string): Promise<Proposal> {
  const response = await axiosInstance.get(`/proposals/${id}`);
  return response.data;
}

export async function createProposal(proposalData: ProposalFormData): Promise<Proposal> {
  const response = await axiosInstance.post('/proposals', proposalData);
  return response.data;
}

export async function updateProposal(id: string, proposalData: Partial<ProposalFormData>): Promise<Proposal> {
  const response = await axiosInstance.patch(`/proposals/${id}`, proposalData);
  return response.data;
}

export async function deleteProposal(id: string): Promise<{ message: string; deleted: Proposal }> {
  const response = await axiosInstance.delete(`/proposals/${id}`);
  return response.data;
}

export async function sendProposal(id: string): Promise<Proposal> {
  const response = await axiosInstance.patch(`/proposals/${id}/send`);
  return response.data;
}

export const proposalService = {
  getProposals,
  getProposalById,
  createProposal,
  updateProposal,
  deleteProposal,
  sendProposal,
};